import { AddressCollectionSchema } from "@redotech/redo-return-core-common/address-collection";
import * as z from "zod";

export const getAddressesByIds = {
  name: "getAddressesByIds" as const,
  input: z.object({ ids: z.array(z.string()) }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
};
